import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

@Component({
    selector: 'reports-report-card',
    templateUrl: './report-card.component.html',
    styleUrls: ['./report-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCardComponent {
    @Input() title = '';
    @Input() icon = 'file-text';
    @Input() tooltip = 'Download Report';
    @Output() action = new EventEmitter<void>();

    emitAction(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.action.emit();
    }
}